/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */

// this is a global function which will be executed from the MAUI wrapper app
// and will eventually trigger the events, which will be picked up by Angular
function fireEvent(eventname, data) {
  if(eventname) {
      window.dispatchEvent(new CustomEvent(eventname, { detail: data }));
  }
}